export default __webpack_public_path__ + "static/media/arrow-green.6b343a4e.svg";